export const GET_POPUP_SETUP = 'GET_POPUP_SETUP';
export const GET_POPUP_SETUP_SUCCESS = 'GET_POPUP_SETUP_SUCCESS';

export const ADD_POPUP_SETUP = 'ADD_POPUP_SETUP';
export const ADD_POPUP_SETUP_SUCCESS = 'ADD_POPUP_SETUP_SUCCESS';

export const API_ERROR = 'API_ERROR';